
import MobileSubArticle from "@/components/child/product/MobileSubArticle";

export default {
    props: {
        topNum: {
            type: Number
        },
        bar_length: {
            type: Array
        },
        product_ranking_data: {
            type: Array
        },
        top_product_article_data: {
            type: Array
        },
        productDataApiTop: {
            type: Object
        },
        showAnimation: {
            type: Boolean
        }
    },
    data() {
        return {
            isActive: false
        }
    },
    components: {
        MobileSubArticle
    },
    methods: {
        openDetail(dataIndex) {
            const vm = this;
            vm.$emit("openDetail", dataIndex);
        }
    },
    mounted() {
    }
}
